import React, { useContext } from 'react';
import styled from 'styled-components';
import Wave from 'react-wavify';
import { useReducedMotion } from 'framer-motion';
import { ThemeContext } from '../ThemeContext';

const BackgroundContainer = styled.div`
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  z-index: -1;
  background: ${props => {
    if (props.backgroundType === 'solid') {
      return props.backgroundSolidColor;
    }
    return props.theme === 'light' ? '#7dbbf1' : '#0a2342';
  }};
  transition: background-color 0.3s ease;
`;

const WaveContainer = styled.div`
  position: absolute;
  width: 100%;
  bottom: 0;
  left: 0;
  opacity: ${props => props.show ? 1 : 0};
  transition: opacity 0.5s ease;
  pointer-events: none;
`;

const WaveBackground = () => {
  const reduceMotion = useReducedMotion();
  const { theme, backgroundType, backgroundSolidColor } = useContext(ThemeContext);
  
  return (
    <BackgroundContainer theme={theme} backgroundType={backgroundType} backgroundSolidColor={backgroundSolidColor}>
      <WaveContainer show={backgroundType === 'wave'}>
        <Wave 
          fill={theme === 'light' ? '#6FB1EA' : '#0d2e59'}
          paused={!!reduceMotion || backgroundType !== 'wave'}
          options={{
            height: 20,
            amplitude: 25,
            speed: 0.15,
            points: 4
          }}
        />
        <Wave 
          fill={theme === 'light' ? '#5da7e6' : '#184785'}
          paused={!!reduceMotion || backgroundType !== 'wave'}
          style={{ marginTop: '-73px' }}
          options={{
            height: 25,
            amplitude: 30,
            speed: 0.2,
            points: 3
          }}
        />
      </WaveContainer>
    </BackgroundContainer>
  );
};

export default WaveBackground;
